import { render } from "./fuelstock.vue?vue&type=template&id=957b1aaa"
import script from "./fuelstock.vue?vue&type=script&lang=js"
export * from "./fuelstock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__